import Cookies from 'js-cookie';
import DEFAULTS from '../constants/pricing/defaults';
import { EI_PLANS, MC_PLANS } from '../constants/pricing/plans';
import { START_FREE_PACKAGES, SIGNUP_URL } from '../constants/pricing/config';

export function getUrlParameter(param) {
  if (typeof window === 'undefined') return false;
  const pageUrl = window.location.search.substring(1);
  const urlParams = pageUrl.split('&');
  const paramKeyVal = urlParams.filter((str) => str.includes(`${param}=`));
  const val = paramKeyVal.length > 0 ? paramKeyVal[0].split('=')[1] : false;
  return val;
}

export function setCookie(cookieVal) {
  if (typeof window !== 'undefined') {
    Cookies.set(
      'tneSignUpVals',
      { ...cookieVal },
      { path: '/', expires: 30, domain: window.location.hostname }
    );
  }
}

export function startFree(event) {
  if (event) event.preventDefault();

  setCookie({ ...DEFAULTS, packages: { ...START_FREE_PACKAGES } });

  if (typeof window !== 'undefined') {
    window.location.assign(SIGNUP_URL);
  }
}

export function trackCheckout(currentState, sgPricingVersion) {
  if (typeof window === 'undefined' || !window.dataLayer) {
    return;
  }

  const { ip, ease } = currentState.addons;

  const eventAction =
    ip || ease !== 3 ? 'continue_with_addons' : 'continue_without_addons';

  const data = {
    event: 'pricingFunnel',
    eventAction,
    pricingVersion: sgPricingVersion,
    tab: currentState.activeTab, // ei or mc
    currentState, // object representation of pricing state
  };
  window.dataLayer.push(data);
}

export function isValidPricingCookie(vals) {
  if (typeof vals !== 'object') return false;

  /**
   * Ensure the EI package ID exists in the plans object
   * null is the default value and is valid
   */
  if (
    vals.packages.e !== null &&
    !Object.values(EI_PLANS)
      .flatMap((plan) => Object.values(plan.packages))
      .some((pkg) => pkg.id === vals.packages.e)
  )
    return false;

  /**
   * Ensure the MC package ID exists in the plans object
   * null is the default value and is valid
   */
  if (
    vals.packages.mc !== null &&
    !Object.values(MC_PLANS)
      .flatMap((plan) => Object.values(plan.packages))
      .some((pkg) => pkg.id === vals.packages.mc)
  )
    return false;

  return true;
}
